export default __webpack_public_path__ + "static/media/no-product.dfc9c90f.gif";